import { TutorialStep } from "..";

export const NewProjectBtnSteps: TutorialStep[] = [
  {
    target: "#new-project-btn",
    content: "새 프로젝트를 만들어보세요. 버튼을 직접 눌러 시작합니다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
];
